import React, { useContext, useEffect, useRef, useState } from "react";

import makeStyles from '@mui/styles/makeStyles';
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import Avatar from "@mui/material/Avatar";
import IconButton from "@mui/material/IconButton";

import messages from "../services/messages";
import config from "../config";
import ShareDialog from "./ShareDialog";
import LanguageContext from "../LanguageContext";
import firebase from "../firebase";
import Button from "@mui/material/Button";
import UserService from "../services/UserService";
import { Close, Schedule } from "@mui/icons-material";
import { Dialog, Paper } from "@mui/material";
import { WhatsappShareButton } from "react-share";

const useStyles = makeStyles((theme) => ({
  root: {
    borderRadius: "8px",
  },
  joinButton: {
    marginTop: theme.spacing(1),
    // marginLeft: theme.spacing(1),
    // marginRight: theme.spacing(1),
  },
  scheduleIcon: {
    marginBottom: theme.spacing(-0.6),
    height: theme.spacing(2.5),
  },
  contentContainer: {},
  authorName: {
    marginLeft: theme.spacing(-1),
  },
  shareIconContainer: {
    // marginTop: theme.spacing(1),
  },
  shareIcon: {
    marginTop: theme.spacing(1.7),
    height: theme.spacing(2.5),
  },
  avatar: { width: theme.spacing(3.5), height: theme.spacing(3.5) },

  authorContainer: {
    // marginBottom: theme.spacing(0.5),
    // marginTop: theme.spacing(0.5),
    alignItems: "center",
  },
  ongoingTagContainer: {
    marginTop: theme.spacing(1),
  },
  ongoingTag: {
    color: "#FFFFFF",
    fontSize: theme.spacing(1.5),
  },
  ongoingTagText: {
    background: `#E63A57`,
    borderRadius: theme.spacing(0.5),
    paddingLeft: theme.spacing(1),
    paddingTop: theme.spacing(0.5),
    paddingRight: theme.spacing(1),
    paddingBottom: theme.spacing(0.5),
  },
  ongoingTagTextBullet: {
    height: theme.spacing(0.75),
    paddingRight: theme.spacing(0.5),
    marginBottom: theme.spacing(0.2),
  },
}));

function LiveContentCard(props) {
  const classes = useStyles();
  const [openShareDialog, setOpenShareDialog] = React.useState(false);
  const [ytModal, setYtModal] = useState(false);
  const [ytWatch, setYtWatch] = useState(0);
  const ytRef = useRef(null);

  const handleClickOpen = () => {
    setOpenShareDialog(true);
  };
  const language = useContext(LanguageContext);
  let { mobile } = UserService.getUserInfo();

  const handleClose = (value) => {
    setOpenShareDialog(false);
  };

  const getShareText = () => {
    let shareText = `🎥 ${props.liveMeeting.sessionTopic} ${messages["cropPage.upcoming.shareText1"][language]} ${props.liveMeeting.cropName}  ${messages["cropPage.upcoming.shareText2"][language]} ${props.liveMeeting.startTime} ${messages["cropPage.upcoming.shareText3"][language]}`;

    return shareText;
  };

  useEffect(() => {
    let interval;

    if (ytModal) {
      interval = setInterval(() => {
        firebase.analytics().logEvent("live_class_attended", {
          crop_name: props.liveMeeting.crop.name_en,
          author_name: props.liveMeeting.author.name_en,
          session_topic: props.liveMeeting.sessionTopic,
          week: props.liveMeeting.week,
          mobile,
          duration: 60,
          state: props.liveMeeting.state[0]?.name_en
            ? props.liveMeeting.state[0].name_en
            : "",
          position: props.position,
          class_start_time: props.liveMeeting.startTime,
          user_type: props.userType,
          farmer_crops: JSON.stringify(props.farmerCrops),
          user_source: props?.userSource,
        });
      }, 60000);
    }
    return () => {
      clearInterval(interval);
    };
  }, [ytModal]);
  const share = async (event) => {
    event.stopPropagation();
    firebase.analytics().logEvent("live_class_shared_on_whatsapp", {
      mobile,
      crop_name: props.liveMeeting.crop.name_en,
      author_name: props.liveMeeting.author.name_en,
      session_topic: props.liveMeeting.sessionTopic,
      week: props.liveMeeting.week,
      state: props.liveMeeting.state[0]?.name_en
        ? props.liveMeeting.state[0].name_en
        : "",
      position: props.position,
      user_type: props.userType,
      farmer_crops: JSON.stringify(props.farmerCrops),
      class_start_time: props.liveMeeting.startTime,
      user_source: props?.userSource,
    });
  };

  const handleYtModal = () => {
    setYtModal(true);
    firebase.analytics().logEvent("live_class_joined", {
      crop_name: props.liveMeeting.crop.name_en,
      author_name: props.liveMeeting.author.name_en,
      session_topic: props.liveMeeting.session_topic,
      week: props.liveMeeting.week,
      position: props.position,
      state: props.liveMeeting.state[0]?.name_en
        ? props.liveMeeting.state[0].name_en
        : "",
      class_start_time: props.liveMeeting.startTime,
      user_type: props.userType,
      farmer_crops: JSON.stringify(props.farmerCrops),
      join_type: "youtube",
      user_source: props?.userSource,
    });
  };

  return <>
    <div id="player"></div>
    <Card className={classes.root} variant={"outlined"}>
      <div style={{ backgroundColor: props.liveMeeting.crop.color }}>
        <CardContent>
          <Grid
            container
            direction="row"
            justifyContent={"flex-start"}
            alignItems={"center"}
          >
            <Grid item xs={9}>
              <Grid
                container
                direction="row"
                justifyContent="flex-start"
                alignItems="center"
              >
                <Grid item>
                  <Typography variant={"h6"}>
                    {props.liveMeeting.cropName}
                    {props.liveMeeting.week &&
                      props.liveMeeting.week !== "" && <> &bull; </>}
                    {props.liveMeeting.week}
                  </Typography>
                </Grid>
              </Grid>
              <Grid
                container
                direction="row"
                justifyContent="flex-start"
                alignItems="flex-end"
                className={classes.ongoingTagContainer}
              >
                <Grid item xs={12}>
                  <Typography
                    variant={"body2"}
                    className={classes.ongoingTag}
                  >
                    <span className={classes.ongoingTagText}>
                      <img
                        src="../../icons/bullet.svg"
                        alt="bullet"
                        className={classes.ongoingTagTextBullet}
                      />
                      {messages[`dashboard.live.ongoing`][language]}
                    </span>
                  </Typography>

                  {/*<Chip*/}
                  {/*  style={{ backgroundColor: "rgba(255, 255, 255, 0.2)" }}*/}
                  {/*  label={props.upcomingMeeting.startTime}*/}
                  {/*  size={"small"}*/}
                  {/*/>*/}
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={3}>
              <CardMedia
                component="img"
                height="70"
                image={props.liveMeeting.cropImage}
                alt={props.liveMeeting.cropName}
                title={props.liveMeeting.cropName}
              />
            </Grid>
          </Grid>
        </CardContent>
      </div>
      <CardContent className={classes.contentContainer}>
        <Grid
          container
          direction="row"
          justifyContent="flex-start"
          alignItems="center"
        >
          <Grid item xs={12}>
            <Typography gutterBottom variant="body2">
              {props.liveMeeting.longDescription}
            </Typography>
          </Grid>
        </Grid>

        <Grid
          container
          direction="row"
          justifyContent="flex-start"
          alignItems="center"
          className={classes.authorContainer}
        >
          <Grid item xs={2}>
            <Avatar
              aria-label="author"
              src={props.liveMeeting.authorImage}
              className={classes.avatar}
              alt={
                props.liveMeeting && props.liveMeeting.authorName
                  ? props.liveMeeting.authorName
                  : "author"
              }
            >
              {props.liveMeeting && props.liveMeeting.authorName && (
                <>props.liveMeeting.authorName.charAt(0)</>
              )}
            </Avatar>
          </Grid>
          <Grid item xs={8}>
            <Typography variant={"caption"}>
              {messages["dashboard.live.byAuthor"][language]}
              {props.liveMeeting.authorName}
            </Typography>
          </Grid>
          <Grid item xs={2}>
            <WhatsappShareButton
              url={`https://agrostar.onelink.me/9ngX/gold${props.userState?.code?.toLowerCase()}`}
              title={`${getShareText()}`}
              onClick={share}
              className={classes.shareIconContainer}
            >
              <img
                className={classes.shareIcon}
                src="../../icons/whatsapp.svg"
                alt="whatsapp-share"
              />
            </WhatsappShareButton>
          </Grid>
        </Grid>
        <Grid container direction="row" justifyContent="center" alignItems="center">
          <Grid item xs={12}>
            {!props.liveMeeting.yt ? (
              <Button
                fullWidth
                className={classes.joinButton}
                variant={"contained"}
                color={"primary"}
                href={props.liveMeeting.joinUrl}
                target={`_blank`}
                onClick={() => {
                  firebase.analytics().logEvent("live_class_joined", {
                    crop_name: props.liveMeeting.crop.name_en,
                    author_name: props.liveMeeting.author.name_en,
                    session_topic: props.liveMeeting.sessionTopic,
                    week: props.liveMeeting.week,
                    mobile,
                    position: props.position,
                    state: props.liveMeeting.state[0]?.name_en
                      ? props.liveMeeting.state[0].name_en
                      : "",
                    class_start_time: props.liveMeeting.startTime,
                    user_type: props.userType,
                    farmer_crops: JSON.stringify(props.farmerCrops),
                    join_type: "zoom",
                    user_source: props?.userSource,
                  });
                }}
              >
                {messages["dashboard.live.joinButton"][language]}
              </Button>
            ) : (
              <Button
                fullWidth
                className={classes.joinButton}
                variant={"contained"}
                color={"primary"}
                onClick={handleYtModal}
              >
                {messages["dashboard.live.joinButton"][language]}
              </Button>
            )}
          </Grid>
        </Grid>
      </CardContent>
    </Card>
    <ShareDialog
      handleClose={handleClose}
      sessionTopic={props.liveMeeting.sessionTopic}
      week={props.liveMeeting.week}
      shareText={`${messages["agrostargold"][language]} `}
      shortDescription={`${props.liveMeeting.cropName} - ${props.liveMeeting.shortDescription}`}
      url={window.location.href}
      handleOpen={handleClickOpen}
      open={openShareDialog}
      mobile={mobile}
      cropName={props.liveMeeting.crop.name_en}
      authorName={props.liveMeeting.author.name_en}
      position={props.position}
      userType={props.userType}
      state={props?.liveMeeting?.state[0]?.name_en}
      startTime={props?.liveMeeting.startTime}
      userSource={props?.userSource}
      classType={`live_class`}
    />
    <Dialog fullScreen open={ytModal} classes={classes.ytDialog}>
      <Close
        onClick={() => setYtModal(false)}
        className={classes.ytPlayerCloseIcon}
      />
      <Paper elevation={0} className={classes.ytPlayer} square={true}>
        <iframe
          width="90%"
          height="88%"
          src={`https://www.youtube.com/embed/${
            props.liveMeeting.page_url.split("/")[3]
          }?autoplay=1&rel=1&modestbranding=1&enablejsapi=1`}
          frameborder="0"
          allowFullScreen={true}
          ref={ytRef}
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        ></iframe>
      </Paper>
    </Dialog>
  </>;
}

export default LiveContentCard;
